import type { StoreState } from '../index';
import type { Widget } from './config';

export const getPageSelectedPresetName = (state: StoreState, page: string): string => {
  const { selectedPreset } = state.dashboardConfiguration;

  return selectedPreset[page];
};

export const getPageCustomConfigurationPreset = (state: StoreState, page: string): Widget[] => {
  const { config } = state.dashboardConfiguration;

  return config.presets[page].custom;
};

export const getPageSelectedPresetConfiguration = (state: StoreState, page: string): Widget[] => {
  const { config, selectedPreset } = state.dashboardConfiguration;

  return config.presets[page][selectedPreset[page]];
};

export const getColumnsConfig = (state: StoreState, page: string, log?: string): string[] => {
  const { columnsConfig } = state.dashboardConfiguration.config;

  if (log) {
    return columnsConfig.log[log] || [];
  }

  const pageColumns = columnsConfig[page];
  return Array.isArray(pageColumns) ? pageColumns : [];
};
